export type SkeletonLoaderProps = {
    height?: string;
    width?: string;
};

function Skeleton({ height = '100%', width = '100%' }: SkeletonLoaderProps): JSX.Element {
    return <div className={'animate-pulse bg-gray-100 rounded'} style={{ height, width }}></div>;
}
export default Skeleton;
